// Shared constants for tracking page builder

// Drag and drop
export const DRAG_THRESHOLD = 3;

// Mobile view
export const MOBILE_ROWS = 9;
export const MOBILE_VIEW_WIDTH = 432;
export const MOBILE_VIEW_MIN_HEIGHT = 848;

// Zoom settings
export const DEFAULT_ZOOM_LEVEL = 0.75;
export const MIN_ZOOM = 0.25;
export const MAX_ZOOM = 2;
export const ZOOM_STEP = 0.25;
